export const authLayoutText = {
  line1: "Perfect Matches",
  line2: "Forever Begins!",
  line3: "Finding Love, Creating Bonds",
};
